import React from 'react';
import { MegaMenuItem } from '../MegaMenuItem';
import { hasProperty } from '@helpers/objectHelpers';
import './MegaMenuColumn.scss';
import {
  MegaMenuColumn as MegaMenuColumnType,
  MegaMenuColumnSection,
  Section,
} from '@layouts/MegaMenu/MegaMenu.types';

type MegaMenuColumnData = MegaMenuColumnType | MegaMenuColumnSection | Section;

interface MegaMenuColumnProps {
  items: MegaMenuColumnType[] | MegaMenuColumnSection[] | Section[];
  level: number;
}

export const MegaMenuColumn = ({ items, level }: MegaMenuColumnProps) => {
  return (
    <>
      {items?.map((columnData: MegaMenuColumnData, index: number) => {
        const columnChildren =
          ('ColumnAndSection' in columnData && columnData.ColumnAndSection) ||
          ('Children' in columnData && columnData.Children) ||
          ('Sections' in columnData && columnData.Sections);

        const columnHasChildren =
          columnChildren?.length > 0 &&
          hasProperty(columnData, 'NoSubCategory') &&
          columnData.NoSubCategory === false;

        return (
          <MegaMenuItem
            key={index}
            level={level}
            hasChildren={columnHasChildren}
            href={columnData.UrlSegment || ('HeaderPage' in columnData && columnData.HeaderPage)}
            title={
              ('Title' in columnData && columnData.Title) ||
              ('Name' in columnData && columnData.Name) ||
              ''
            }
            items={columnChildren as Section[]}
          />
        );
      })}
    </>
  );
};
